import { assertServiceHost, axiosClient } from '@nx-frontend/shared/api';
import { OrgServiceOrgUsageDto, ServicePayload } from '@nx-frontend/shared/types';
import { MandateProps } from '@nx-frontend/shared/types/mandate-props';

interface GetOrgUsagePayload extends MandateProps<ServicePayload, 'userId'> {
  orgId: string;
}

export async function getOrgUsage({ host, orgId, userId }: GetOrgUsagePayload): Promise<OrgServiceOrgUsageDto> {
  const response = await axiosClient.get<OrgServiceOrgUsageDto>(`${assertServiceHost(host)}/v1/orgs/${orgId}/usage`, {
    userId,
  });
  return response.data;
}
